"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/prefer-default-export */
exports.getDeviceId = function (deviceId) { return (deviceId ? "deviceId: \"" + deviceId + "\"" : ''); };
exports.matchingSelectedTextTrack = function (textTracks, selectedTextTrack) {
    if (!textTracks || textTracks.length === 0 || !selectedTextTrack) {
        return undefined;
    }
    var matchedSelectedTextTrack = textTracks.find(function (textTrack) { return textTrack.label === selectedTextTrack.label; });
    return matchedSelectedTextTrack;
};
//# sourceMappingURL=Playback.js.map